import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class ArtifactsArtifactRoute extends Route {
  @service store;

  model(params) {
    return this.store.findRecord('artifact', params.artifact_id);
  }
}

export default instrumentRoutePerformance(ArtifactsArtifactRoute);
